(ns ui.agent.register
  "UI register of the agent slice: the Agents page under /ui/agents,
   its create modal and the `:agents/poll` action that keeps the page
   current while a machine is being set up. The sidebar entry is
   behind `ui.hidden-features/shown?` (dark launch)."
  (:require [parts.replicant.query :as query]
            [ui.agent.create-modal :as create-modal]
            [ui.agent.page :as page]))

(def poll-ms
  5000)

(defn poll!
  "Asks for the agents again in a while, as long as the page is open and
   a machine is being set up; one timer at a time."
  [{:keys [store ui/event-handler]}]
  (when-not (:agents/poll-timer @store)
    (swap! store assoc :agents/poll-timer
           (js/setTimeout
             (fn []
               (swap! store dissoc :agents/poll-timer)
               (when (and (= :pages/agents (get-in @store [:location :location/page-id]))
                          (page/provisioning? (:agents (query/get-result @store page/agents-query))))
                 (event-handler {} [[:data/query page/agents-query]
                                    [:agents/poll]])))
             poll-ms))))

(def register
  [page/page
   create-modal/modal
   {:ui.action/kind :agents/poll
    :ui.action/handler poll!}])
